import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { PlaySpaceFormComponent } from "./play-space.component";
import { PlaySpaceService } from "../shared/services/playspace.service";
import { IpInfoLocationService } from "../shared/services/ipinfo.location.service";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { NgxSpinnerModule } from "ngx-spinner";
import { GoogleMapsModule } from '@angular/google-maps';
import { TranslateModule } from '@ngx-translate/core';
import { ChatService } from "../shared/services/chat.service";
import { NogoshIconPipe } from "../shared/icons/nogosh-icon.pipe";
import { ScreenShellComponent } from "../shared/screen-shell/screen-shell.component";
import { CoreModule } from "../core/core.module";

@NgModule({
  imports: [CommonModule, FormsModule, TypeaheadModule, NgxSpinnerModule, GoogleMapsModule, TranslateModule, NogoshIconPipe, ScreenShellComponent, CoreModule],
  exports: [PlaySpaceFormComponent],
  declarations: [PlaySpaceFormComponent],
  providers: [PlaySpaceService, IpInfoLocationService, ChatService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PlaySpaceModule {}
